import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  static targets = ["icon"];

  connect() {
    App.Helpers.listenToCustomEvent(document, "expand-all-transactions", this.expand.bind(this));
    App.Helpers.listenToCustomEvent(document, "close-all-transactions", this.close.bind(this));
  }

  expand() {
    !this.open && this.element.click();
  }

  close() {
    this.open && this.element.click();
  }

  toggle(event) {
    event && event.preventDefault();
    this.open = !this.open;
    document.dispatchEvent(createCustomEvent(this.eventName, this.element, { containerID: this.containerID }));
  }

  //
  // GETTERS AND SETTERS
  //

  get open() {
    return ["1", 1, true, "true"].includes(this.data.get("is-open"));
  }

  set open(value) {
    this.iconTarget.classList[value ? "add" : "remove"](`fa-${this.iconType}-up`);
    this.iconTarget.classList[value ? "remove" : "add"](`fa-${this.iconType}-down`);
    this.data.set("is-open", value ? "1" : "0")
  }

  get eventName() {
    return `detail:${this.open ? "expand" : "collapse"}`;
  }

  get containerID() {
    return this.data.get("container-id");
  }

  get iconType() {
    return this.data.get("icon-type");
  }
};



// WEBPACK FOOTER //
// ./app/components/buttons/assets/javascript/buttons-expand-details-button-controller.js